module.exports = __webpack_public_path__ + "img/alejandra-marchi.146d4ee8.jpg";